export default __webpack_public_path__ + "static/webRotator/svg/94a121c3e4c3de65e9c92df26011c0e2.svg";